export default __webpack_public_path__ + "static/media/react-bg.66bf90fb.svg";